/* eslint-disable import/no-cycle */
import axiosIns, { axiosDefault } from '@/libs/axios'
import { requestApi } from '@/libs/secret'
// import { axiosInsNoEnc } from '@/libs/axios'

const month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
/* eslint-disable no-return-assign */
export default {
  namespaced: true,
  state: {
    // creditBalance: '0',
    dataBudget: {
      items: {
        total: 6,
        per_page: 6,
        current_page: 1,
        from: 1,
        to: 6,
        data: [],
      },
      adminFields: [
        { key: 'company_name', label: 'Company Name', sortable: true },
        { key: 'month', label: 'Month', sortable: true },
        { key: 'year', label: 'Year', sortable: true },
        { key: 'total', label: 'Cost', sortable: true },
        { key: 'invoice_number', label: 'Invoice Number', sortable: true },
        { key: 'actions', label: '' },
      ],
      fields: [
        { key: 'month', label: 'Month', sortable: true },
        { key: 'year', label: 'Year', sortable: true },
        { key: 'total', label: 'Cost', sortable: true },
        { key: 'invoice_number', label: 'Invoice Number', sortable: true },
        { key: 'actions', label: '' },
      ],
      // status: [
      //   {
      //     1: 'Unpaid', 2: 'Waiting Approval', 3: 'Paid', 4: 'Rejected', 5: 'Cancelled',
      //   },
      //   {
      //     1: 'warning', 2: 'warning', 3: 'success', 4: 'danger', 5: 'danger',
      //   },
      // ],
      sortBy: '',
      sortDesc: false,
      search: '',
      startdate: '',
      enddate: '',
    },
    detailBudget: {},
    companyFilter: [],
    company: [],
    startDateFilter: '',
    endDateFilter: '',
  },
  getters: {
    getBudgetItem: state => state.dataBudget.items,
    getBudgetAdminField: state => state.dataBudget.adminFields,
    getBudgetField: state => state.dataBudget.fields,
    getCurrentPage: state => state.dataBudget.items.current_page,
    getSortBy: state => state.dataBudget.sortBy,
    getSortDesc: state => state.dataBudget.sortDesc,
    getSearch: state => state.dataBudget.search,
    getStartDate: state => state.dataBudget.startdate,
    getEndDate: state => state.dataBudget.enddate,
    getBudget: state => state.detailBudget,
    getCompanyFilter: state => state.companyFilter,
    getCompany: state => state.company,
    getStartDateFilter: state => state.startDateFilter,
    getEndDateFilter: state => state.endDateFilter,
  },
  mutations: {
    SET_ITEM_DATA: (state, value) => (value ? (state.dataBudget.items = value) : (state.dataBudget.items = [])),
    SET_BUDGET_CURRENT_PAGE: (state, value) => (value ? (state.dataBudget.items.current_page = value) : (state.dataBudget.items.current_page = 1)),
    SET_BUDGET_SORT_BY: (state, value) => (value ? (state.dataBudget.sortBy = value) : (state.dataBudget.sortBy = '')),
    SET_BUDGET_SORT_DESC: (state, value) => (value ? (state.dataBudget.sortDesc = value) : (state.dataBudget.sortDesc = false)),
    SET_BUDGET_SEARCH: (state, value) => (value ? (state.dataBudget.search = value) : (state.dataBudget.search = '')),
    SET_STARTDATE: (state, value) => (value ? (state.dataBudget.startdate = value) : (state.dataBudget.startdate = '')),
    SET_ENDDATE: (state, value) => (value ? (state.dataBudget.enddate = value) : (state.dataBudget.enddate = '')),
    SET_DETAIL_BUDGET: (state, value) => (value ? (state.detailBudget = value) : (state.detailBudget = {})),
    SET_COMPANY_FILTER: (state, value) => (value ? (state.companyFilter = value) : (state.companyFilter = [])),
    SET_COMPANY: (state, value) => (value ? (state.company = value) : (state.company = [])),
    SET_START_DATE_FILTER: (state, value) => (value ? (state.startDateFilter = value) : (state.startDateFilter = '')),
    SET_END_DATE_FILTER: (state, value) => (value ? (state.endDateFilter = value) : (state.endDateFilter = '')),
  },
  actions: {
    clearTable({ commit }) {
      commit('SET_BUDGET_CURRENT_PAGE')
      commit('SET_BUDGET_SORT_BY')
      commit('SET_BUDGET_SORT_DESC')
      commit('SET_STARTDATE')
      commit('SET_ENDDATE')
      commit('SET_BUDGET_SEARCH')
      commit('SET_COMPANY')
      commit('SET_COMPANY_FILTER')
      commit('SET_START_DATE_FILTER')
      commit('SET_END_DATE_FILTER')
    },
    // eslint-disable-next-line no-unused-vars
    getDataList({ commit, rootState, getters }, payload) {
      const desc = (getters.getSortDesc) ? 'desc' : 'asc'
      // const type = typeof payload !== 'undefined' ? payload.type : ''
      // const format = typeof payload !== 'undefined' ? payload.format : ''
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      const user = rootState.auth.userData.data.id
      const role = rootState.auth.userData.data.Account.role_id
      const dept = rootState.auth.userData.data.departement.id
      // const clientQuery = `user=${user}&page=${getters.getCurrentPage}&start_period=${getters.getStartDate}&end_period=${getters.getEndDate}&sortby=${getters.getSortBy}&sortdir=${desc}&filter=${getters.getSearch}&type=${type}&downloadFormat=${format}`
      // const adminQuery = `page=${getters.getCurrentPage}&start_period=${getters.getStartDate}&end_period=${getters.getEndDate}&sortby=${getters.getSortBy}&sortdir=${desc}&filter=${getters.getSearch}&type=${type}&downloadFormat=${format}`
      const clientQuery = `page=${getters.getCurrentPage}sortby=${getters.getSortBy}&sortdir=${desc}&filter=${getters.getSearch}`
      const adminQuery = `page=${getters.getCurrentPage}&sortby=${getters.getSortBy}&sortdir=${desc}&filter=${getters.getSearch}`
      const param = (role === 2 && dept === 1) ? adminQuery : clientQuery
      const dateMonth = new Date(getters.getStartDate)
      let monthName = (getters.getStartDate === '') ? '' : month[dateMonth.getMonth()]
      const dateYear = new Date(getters.getEndDate)
      let yearName = (getters.getEndDate === '') ? '' : dateYear.getFullYear()
      const dataSend = {
        month: monthName,
        year: yearName,
        company: getters.getCompany,
        search: getters.getSearch,
      }
      if (role === 2 && dept === 1) {
        dataSend.user = ''
      } else {
        dataSend.user = user
      }

      // commit('SET_ITEM_DATA')
      // commit('SET_COMPANY_FILTER', getters.getCompany)
      // commit('SET_START_DATE_FILTER', getters.getStartDate)
      // commit('SET_END_DATE_FILTER', getters.getEndDate)
      return new Promise((resolve, reject) => {
        const queryParam = requestApi(param)
        axiosIns.post(`settlement?req=${queryParam.req}`, dataSend, { headers }).then(response => {
          if (response) {
            commit('SET_ITEM_DATA', response.data.data)
            resolve(response.data.data)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    getDataListDownload({ rootState, getters }, payload) {
      const desc = (getters.getSortDesc) ? 'desc' : 'asc'
      const type = typeof payload !== 'undefined' ? payload.type : ''
      const format = typeof payload !== 'undefined' ? payload.format : ''
      // let headers = {
      //   headers: {
      //     Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      //   },
      //   // responseType: 'blob',
      // }
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        const queryParam = requestApi(`page=${getters.getCurrentPage}&start_period=${getters.getStartDate}&end_period=${getters.getEndDate}&sortby=${getters.getSortBy}&sortdir=${desc}&filter=${getters.getSearch}&type=${type}&downloadFormat=${format}`)
        axiosIns.get(`invoice?req=${queryParam.req}`, { headers }).then(response => {
          if (response) {
            resolve(response.data)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    detailBudgets({ commit, rootState }, payload) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get(`settlement/${payload}`, { headers }).then(response => {
          if (response) {
            commit('SET_DETAIL_BUDGET', response.data.data)
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    setCreditBalance({ commit, rootState }) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get('account/creditBalance', { headers }).then(response => {
          if (response) {
            commit('SET_CREDIT_BALANCE', response.data.data.saldo)
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    downloadBudgetDetail({ rootState }, payload) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get(`invoice/${payload}/download`, { headers }).then(response => {
          if (response) {
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    downloadTable({ getters, rootState }, payload) {
      const desc = (getters.getManageSortDesc) ? 'desc' : 'asc'
      const user = rootState.auth.userData.data.id
      const role = rootState.auth.userData.data.Account.role_id
      const dept = rootState.auth.userData.data.departement.id
      const dateMonth = new Date(getters.getStartDate)
      let monthName = (getters.getStartDate === '') ? '' : month[dateMonth.getMonth()]
      const dateYear = new Date(getters.getEndDate)
      let yearName = (getters.getEndDate === '') ? '' : dateYear.getFullYear()
      const dataSend = {
        year: yearName,
        month: monthName,
        company: getters.getCompany,
        search: getters.getSearch,
        filter: getters.getSearch,
        sortBy: getters.getSortBy,
        sortdirt: desc,
        type: payload,
      }
      if (role !== 2 || dept !== 1) {
        dataSend.user = user
      }

      return new Promise((resolve, reject) => {
        // const queryParam = requestApi(`user=${user}&filter=${getters.getSearch}&sortby=${getters.getSortBy}&sortdir=${desc}`)
        axiosDefault.post('settlement/download/table', dataSend, { responseType: 'arraybuffer' })
          .then(response => {
            // const newData = response.data
            // let blob = new Blob([response.data], { type: 'application/pdf' }),
            // url = window.URL.createObjectURL(blob)
            // window.open(url)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
  },
}
